import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  CustomCheckbox,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useBalanca, { LOAD_MESSAGE } from './CadastroBalancaHook'
import BalancaModal from './BalancaModal/BalancaModal'

function CadastroBalanca({ selectedTp, dispatch, history }) {
  const { state, localDispatch } = useBalanca()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.INITIAL_GET:
        dispatch(showLoadingBox('Carregando balanças', 'Aguarde...'))
        localDispatch.getBalancas(state.selectedTp)
        break
      default:
        break
    }
  }, [state.loadingMessage, state.selectedTp])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const header = (
    <CustomDataTableHeader
      onChange={value => localDispatch.onGlobalFilterChange(value)}
      value={state.globalFilter}
    />
  )

  return (
    <div>
      <PageHeader>9.1 - Cadastro de Balança</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(selectedTp)}
          showBtnNovo={!!selectedTp}
          onVoltar={history.goBack}
        >
          <DataTable
            header={header}
            value={state.balancas}
            paginator
            rows={15}
            selectionMode="single"
            onRowClick={e => localDispatch.onRowClick(e.data)}
            globalFilter={state.globalFilter}
            emptyMessage="Nenhuma balança encontrada"
            dataKey="id"
          >
            <Column field="id" header="Código" style={{ width: 80 }} />
            <Column field="name" header="Nome" />
            <Column
              header="Ativa"
              body={row => <CustomCheckbox disabled checked={!!row.actived} onChange={() => {}} />}
              style={{ width: 120, textAlign: 'center' }}
            />
          </DataTable>
        </CustomPanel>
      </div>

      <BalancaModal
        show={state.modal.show}
        data={state.modal.data}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CadastroBalanca))
